// FETCH ALL PROPERTIES FROM TEAM DETAILS
export const FETCH_TEAM_DETAILS_REQUEST = 'FETCH_TEAM_DETAILS_REQUEST';
export const FETCH_TEAM_DETAILS_SUCCESS = 'FETCH_TEAM_DETAILS_SUCCESS';
export const FETCH_TEAM_DETAILS_FAILURE = 'FETCH_TEAM_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM DETAILS
export const FETCH_TEAM_DETAILS_EMPLOYEE_LIST_REQUEST = 'FETCH_TEAM_DETAILS_EMPLOYEE_LIST_REQUEST';
export const FETCH_TEAM_DETAILS_EMPLOYEE_LIST_SUCCESS = 'FETCH_TEAM_DETAILS_EMPLOYEE_LIST_SUCCESS';
export const FETCH_TEAM_DETAILS_EMPLOYEE_LIST_FAILURE = 'FETCH_TEAM_DETAILS_EMPLOYEE_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_TEAM_DETAILS_ROLE_REQUEST = 'FETCH_TEAM_DETAILS_ROLE_REQUEST';
export const FETCH_TEAM_DETAILS_ROLE_SUCCESS = 'FETCH_TEAM_DETAILS_ROLE_SUCCESS';
export const FETCH_TEAM_DETAILS_ROLE_FAILURE = 'FETCH_TEAM_DETAILS_ROLE_FAILURE';

// CREATE PROPERTIES FOR TEAM DETAILS
export const CREATE_TEAM_DETAILS_REQUEST = 'CREATE_TEAM_DETAILS_REQUEST';
export const CREATE_TEAM_DETAILS_SUCCESS = 'CREATE_TEAM_DETAILS_SUCCESS';
export const CREATE_TEAM_DETAILS_FAILURE = 'CREATE_TEAM_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_TEAM_DETAILS = 'CREATE_USER_FORM_TEAM_DETAILS';

// UPDATE PROPERTIES FOR TEAM DETAILS
export const UPDATE_TEAM_DETAILS_REQUEST = 'UPDATE_TEAM_DETAILS_REQUEST';
export const UPDATE_TEAM_DETAILS_SUCCESS = 'UPDATE_TEAM_DETAILS_SUCCESS';
export const UPDATE_TEAM_DETAILS_FAILURE = 'UPDATE_TEAM_DETAILS_FAILURE';

// FETCH SINGLE TEAM_DETAILS
export const FETCH_SINGLE_TEAM_DETAILS_REQUEST = 'FETCH_SINGLE_TEAM_DETAILS_REQUEST';
export const FETCH_SINGLE_TEAM_DETAILS_SUCCESS = 'FETCH_SINGLE_TEAM_DETAILS_SUCCESS';
export const FETCH_SINGLE_TEAM_DETAILS_FAILURE = 'FETCH_SINGLE_TEAM_DETAILS_FAILURE';

// DELETE PROPERTIES FOR TEAM DETAILS
export const DELETE_TEAM_DETAILS_REQUEST = 'DELETE_TEAM_DETAILS_REQUEST';
export const DELETE_TEAM_DETAILS_SUCCESS = 'DELETE_TEAM_DETAILS_SUCCESS';
export const DELETE_TEAM_DETAILS_FAILURE = 'DELETE_TEAM_DETAILS_FAILURE';

// USERFORM RESET

export const TEAM_DETAILS_USERFORM_RESET = 'TEAM_DETAILS_USERFORM_RESET';
